export default {
  'dashboard-analysis.analysis.test': 'Gongzhuan No.{no} shop',
  'dashboard-analysis.analysis.introduce': 'Introduzir',
  'dashboard-analysis.analysis.total-sales': 'Vendas Totais',
  'dashboard-analysis.analysis.day-sales': 'Vendas do Dia',
  'dashboard-analysis.analysis.visits': 'Visitas',
  'dashboard-analysis.analysis.visits-trend': 'Tendência de Visitas',
  'dashboard-analysis.analysis.visits-ranking': 'Ranking de Visitas',
  'dashboard-analysis.analysis.day-visits': 'Visitas do Dia',
  'dashboard-analysis.analysis.week': 'Taxa Semanal',
  'dashboard-analysis.analysis.day': 'Taxa Diária',
  'dashboard-analysis.analysis.payments': 'Pagamentos',
  'dashboard-analysis.analysis.conversion-rate': 'Taxa de Conversão',
  'dashboard-analysis.analysis.operational-effect': 'Efeito Operacional',
  'dashboard-analysis.analysis.sales-trend': 'Tendência de Vendas das Lojas',
  'dashboard-analysis.analysis.sales-ranking': 'Ranking de Vendas',
  'dashboard-analysis.$2': 'Todo ano',
  'dashboard-analysis.analysis.all-month': 'Todo mês',
  'dashboard-analysis.analysis.all-week': 'Toda semana',
  'dashboard-analysis.analysis.all-day': 'Todo dia',
  'dashboard-analysis.analysis.search-users': 'Pesquisa de Usuários',
  'dashboard-analysis.analysis.per-capita-search': 'Busca Per Capta',
  'dashboard-analysis.analysis.online-top-search': 'Mais Buscadas Online',
  'dashboard-analysis.analysis.the-proportion-of-sales': 'The Proportion Of Sales',
  'dashboard-analysis.channel.all': 'Tudo',
  'dashboard-analysis.channel.online': 'Online',
  'dashboard-analysis.channel.stores': 'Lojas',
  'dashboard-analysis.analysis.sales': 'Vendas',
  'dashboard-analysis.analysis.traffic': 'Tráfego',
  'dashboard-analysis.table.rank': 'Rank',
  'dashboard-analysis.table.search-keyword': 'Palavra chave',
  'dashboard-analysis.table.users': 'Usuários',
  'dashboard-analysis.table.weekly-range': 'Faixa Semanal',
};
